import Spinner from './Spinner';

type Props = {
  title: string;
  subtitle?: string;
};

export default function LoadingState({ title, subtitle }: Props) {
  return (
    <div className="flex flex-1 items-center justify-center w-full">
      <div className="flex flex-col items-center gap-3">
        <Spinner />
        <h2 className="text-2xl font-semibold text-foreground">{title}</h2>
        {subtitle && (
          <p className="text-sm text-muted-foreground">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
